import React from "react";
import { getShopDetailsFromLocalStorage } from "../../localstorage";

const CreateOfferDetailsInfoPreview = ({ form }) => {
	const shopDetails = getShopDetailsFromLocalStorage();
	return (
		<div className="detail-info-box card-box text-left my-3">
			<div className="text-center">
				<h5>Detail info</h5>
			</div>

			<div className="info-row">
				<span className="label">Category:</span>
				<span className="value">{shopDetails.category}</span>
			</div>

			<div className="info-row">
				<span className="label">Sub category:</span>
				<span className="value">{form.subCategoryType}</span>
			</div>

			<div className="info-row">
				<span className="label">Offer Type:</span>
				<span className="value">{form.offerType}</span>
			</div>

			<div className="info-row">
				<span className="label">Offer value:</span>
				<span className="value">{form.offerValue}</span>
			</div>

			<div className="info-row">
				<span className="label">Offer more details:</span>
				<span className="value" style={{ whiteSpace: "pre-line" }}>
					{form.offerLongDetails}
				</span>
			</div>

			<div className="line-seprator">
				<hr />
			</div>
			<div className="t pt-2">
				<h5>Pricing</h5>
			</div>

			<div className="info-row">
				<span className="label">Original price:</span>
				<span className="value">{form.originalPrice}</span>
			</div>

			<div className="info-row">
				<span className="label">Discounted price:</span>
				<span className="value">{form.discountedPrice}</span>
			</div>

			<div className="info-row">
				<span className="label">Min order value:</span>
				<span className="value">{form.minOrderValue}</span>
			</div>

			<div className="info-row">
				<span className="label">Max discount:</span>
				<span className="value">{form.maxDiscount}</span>
			</div>
			<div className="line-seprator">
				<hr />
			</div>
			<h5 className=" pt-3">Termas & conditions</h5>
			<div className="terms-conditions">
				{form.terms &&
					form.terms.map((item) => {
						return <div>* {item}, </div>;
					})}
			</div>
		</div>
	);
};

export default CreateOfferDetailsInfoPreview;
